export default (dateString: string) => {
  // dateString -> 16011995
  return (
    dateString.substring(0, 2) +
    "/" +
    dateString.substring(2, 4) +
    "/" +
    dateString.substring(4, 8)
  );
};
